var locStringAssets = true ?
["../resources/locale-consolidated/[locale]/owa.consolidated.worker.data.14a5c2c4.json"] : [];
var locStringLocale;
var locStringHandler;
(self)._locStrings = {
	addLocstringAsset: function(a) {
		locStringAssets.push(a);
		return locStringHandler ? Promise.resolve(locStringHandler(__webpack_require__.p + a.replace(/\[locale\]/g, locStringLocale))) : Promise.resolve();
	},
	registerHandler: function(locale, handler) {
		locStringLocale = locale;
		locStringHandler = handler;
		return Promise.all(locStringAssets.map(function (a) { return handler(__webpack_require__.p + a.replace(/\[locale\]/g, locale)); }));
	},
};

var chunksLocstringFiles = {};
__webpack_require__.f.owaLocStrings = function(chunkId, promises) {
	if (!(true) && Object.prototype.hasOwnProperty.call(chunksLocstringFiles, chunkId)) {
		promises.push((self)._locStrings.addLocstringAsset(chunksLocstringFiles[chunkId]));
	}
};